module.exports = __webpack_public_path__ + "img/R-C.7ed2e75.png";